import { Component, ElementRef, ViewChild } from '@angular/core';
import { CtaSectionComponent } from "../../cta-section/cta-section.component";

@Component({
  selector: 'app-consultoria-fiscal',
  standalone: true,
  templateUrl: './consultoria-fiscal.component.html',
  styleUrl: './consultoria-fiscal.component.css',
  imports: [CtaSectionComponent],
})
export class ConsultoriaFiscalComponent {
  @ViewChild('servicesSection') servicesSection!: ElementRef;

  isVisible = false;
  private observer: IntersectionObserver | null = null;

  ngAfterViewInit(): void {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.isVisible = true;
            if (this.observer) {
              this.observer.disconnect();
            }
          }
        });
      },
      { threshold: 0.2 }
    );

    if (this.servicesSection?.nativeElement) {
      this.observer.observe(this.servicesSection.nativeElement);
    }
  }

  ngOnDestroy(): void {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}
